import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
  Pipe,
  PipeTransform,
  ViewChild,
} from '@angular/core';

import { fromEvent, Subscription, timer } from 'rxjs';
import { debounce, distinctUntilChanged, map } from 'rxjs/operators';
import { RmSelect } from '../rm-select/rm-select.types';
import { AmplitudeService } from '@web-frontend/shared/amplitude.service';

@Component({
  selector: 'roma-rm-select-v3',
  templateUrl: './rm-select-v3.component.html',
  styleUrls: ['./rm-select-v3.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RmSelectV3Component implements OnInit {
  @ViewChild('inputFilterSearch')
  set input(value: ElementRef<HTMLInputElement>) {
    if (value) {
      this._input = value;
      // this.setFocusInputSearch();
      this.patchFilterArgParams();
      this.watchInputSearch();
    }
  }

  @Input()
  placeholderText = '';

  @Input()
  mode: RmSelect.Type = 'MULTIPLE';

  @Input()
  isAbsolute = false;

  @Input()
  isClearable = false;

  @Input()
  listWidth = '';

  @Input()
  addButtonText = 'general.addUser';

  @Input()
  hasError = false;

  @Input()
  builtFor = '';

  _panelClicked = false;
  _isLoading = false;
  _firstLoad = true;
  @Input()
  @HostBinding('class.is-loading')
  set isLoading(value: boolean) {
    this._isLoading = value;
    //if is changed is loaded to false for second time (latter than load), we open the panel
    if (this._isLoading == false) {
      if (this._firstLoad) {
        this._firstLoad = false;
        this._panelClicked = false;
      } else {
        if (this._panelClicked) {
          this.showPanelElement = true;
        }
        this._panelClicked = false;
      }
    }
  }

  get isLoading() {
    return this._isLoading;
  }

  @Input()
  @HostBinding('class.is-disabled')
  disabled!: boolean;

  @Input()
  items: RmSelect.Items = [];

  @Input()
  activeItems: RmSelect.Items = [];

  @Input()
  inputHeight = '44px';

  @Input()
  type = '';

  @Input()
  showAddButton = false;

  @Input()
  amplitudeEvent = '';

  @Output()
  changeItems = new EventEmitter<RmSelect.Items>();

  @Output()
  addElement = new EventEmitter<MouseEvent>();

  @Input()
  showPanelElement = false;

  @Input()
  showSelectedItems = true;

  @Input()
  isBudgetSettingsSelect = false;

  checkBoxItems: any[] = [];
  filterArgs: { title: string } = { title: '' };

  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    if (
      this.showPanelElement &&
      !this.elRef.nativeElement.contains(event.target)
    ) {
      this.showPanelElement = false;
    }
  }

  private _input: ElementRef<HTMLInputElement>;
  private sub$ = new Subscription();

  firstLoad = true;
  focusOutA = false;
  focusOutB = false;
  anuleFocusOut = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private elRef: ElementRef,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit(): void {
    /* if (this.type === 'taxes') {
      this.listWidth = '300px';
    }*/
  }

  clickPanel(evt: MouseEvent, open?: boolean, from?: string) {
    this._panelClicked = true;
    if (evt) {
      if (open === true || open === false) {
        this.showPanelElement = open;
      } else {
        this.showPanelElement = !this.showPanelElement;
      }

      if (this.showPanelElement) {
        this.focusOutA = true;
        this.focusOutB = false;
      }
      this.draw();
    }
  }

  async delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  anuleFocusOutTimeout() {
    this.anuleFocusOut = true;
    setTimeout(() => {
      this.anuleFocusOut = false;
    }, 200);
  }

  async focusOut(from: string) {
    await this.delay(100);

    if (this.anuleFocusOut == true) {
      return;
    }

    if (from === 'users') {
      this.focusOutA = true;
    }

    if (from === 'status') {
      this.focusOutB = true;
    }

    if (this.focusOutA && this.focusOutB) {
      this.showPanelElement = false;
    }
    this.draw();
  }

  changeSelect(item: RmSelect.Item) {
    this.activeItems = [item];
    this.showPanelElement = false;
    this.changeItems.next(this.activeItems);
    this.draw();
  }

  changeCheckBox(evt, item) {
    if (item.stock || item.price) {
      item = {
        title: item.title,
        value: item.value,
        price: item.price,
        stock: item.stock,
      };
    } else {
      if (this.type === 'taxes') {
        item = {
          _id: item._id,
          name: item.title,
          value: item.value,
          translate: item.translate,
          type: item.type,
        };
      } else {
        item = {
          title: item.title,
          value: item.value,
          translate: item.translate,
        };
      }
    }

    if (evt.checked) {
      //this.checkBoxItems.push(item.value);
      this.activeItems.push(item);
    } else {
      this.activeItems.splice(
        this.activeItems.findIndex((i) => i?.['_id'] === item?.['_id']),
        1
      );
    }

    this.changeItems.next(this.activeItems);
    this.draw();
  }

  searchCheckFilters(item) {
    return (
      this.activeItems.filter((element) => element?.['_id'] === item?._id)
        .length > 0
    );
  }

  addElementHandle(evt: MouseEvent) {
    if (evt) {
      this.addElement.next(evt);
    }
  }

  clearInput(mode: 'in' | 'out') {
    this.activeItems = [];
    this.filterArgs.title = '';
    this.draw();

    if (mode === 'in') {
      this.changeItems.next(this.activeItems);
    }
  }

  removeItem(item) {
    const index = this.activeItems.findIndex((it) => it.title === item.title);
    this.activeItems.splice(index, 1);
    this.filterArgs.title = '';
    this.changeItems.next(this.activeItems);
    this.draw();
  }

  private draw() {
    this.cdr.detectChanges();
  }

  private setFocusInputSearch() {
    if (this._input) {
      this._input.nativeElement.focus();
    }
  }

  private patchFilterArgParams() {
    if (this._input && this.filterArgs.title) {
      this._input.nativeElement.value = this.filterArgs.title;
    }
  }

  private watchInputSearch() {
    this.sub$.add(
      fromEvent(this._input.nativeElement, 'input')
        .pipe(
          distinctUntilChanged(),
          debounce(() => timer(450)),
          map((res) => (res.target as HTMLTextAreaElement).value as string)
        )
        .subscribe(this.changeKeyword.bind(this))
    );
  }

  private changeKeyword(keyword: string) {
    this.filterArgs = {
      title: keyword.toString().toLocaleLowerCase(),
    };
    this.draw();
  }

  emitAmplitudeEvent() {
    if (!this.showPanelElement && this.amplitudeEvent) {
      this.amplitudeService.sendEvent({
        event: 'settings_selectTaxes',
      });
    }
  }
}

@Pipe({
  name: 'searchFilter',
  pure: false,
})
export class SearchFilterPipe implements PipeTransform {
  transform(items: RmSelect.Items, filter: { title: string }): any {
    if (!items?.length || !filter?.title) {
      return items;
    }

    return items.filter((item) =>
      item.title.match(new RegExp(filter.title, 'i'))
    );
  }
}
